<template>
  <layout :title-text="title">
    <div slot="content" class="reg-container">
      <div class="reg-content">
        <p v-for="(item, index) in regList" :key="index">
          <label class="label-content">{{item.label}}</label>
          <span>{{item.detail}}</span>
        </p>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
export default {
  components: {
    Layout
  },
  data () {
    return {
      title: '报名说明',
      regList: [
        {
          label: '报名方式',
          detail: '通过公安大学邀请函进行邮件报名或者在“蓝帽杯”官网网站线上注册报名；'
        },
        {
          label: '参赛人员',
          detail: '高校在读全日制专科生、本科或研究生；'
        },
        {
          label: '参赛队伍',
          detail: '每个队伍3人，每个队伍一名指导老师，每个学校不限制队伍数量；'
        },
        {
          label: '参赛赛区',
          detail: '参赛战队需根据所属高校省份进行赛区选择，未选择的战队大赛组委会会自行分配和安排；'
        },
        {
          label: '资格确认',
          detail: '大赛主办方对报名参赛人员资格进行审查，审查结果将在大赛官网上予以公示。'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.reg-container {
  position: relative;
  width: 1000px;
  margin: 0 auto;
  .reg-content {
    padding-left: 80px;
    text-align: left;
    font-size: 16px;
    font-family: Microsoft YaHei;
    line-height: 18px;
    p:not(:last-child){
      margin-bottom: 30px;
    }
    label {
      display: inline-block;
      height: 47px;
      line-height: 47px;
      width: 169px;
      background: url(../../assets/images/bg_reg_introduction.png) no-repeat 50% 50%;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center !important;
    }
    span {
      display: inline-block;
      margin-left: 22px;
      font-weight: 400;
      color: #5891FA;
    }
  }
}
</style>
